import { render, staticRenderFns } from "./addAppointment.vue?vue&type=template&id=20d0ab68&"
import script from "./addAppointment.vue?vue&type=script&lang=js&"
export * from "./addAppointment.vue?vue&type=script&lang=js&"
import style0 from "./addAppointment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports